if (!customElements.get('references-picker')) {
  class ReferencesPicker extends HTMLElement {
    constructor() {
      super();
      // Die Farbauswahl ist statisch für das aktuelle Produkt.
      // Sie muss beim Größenwechsel NICHT neu gerendert werden,
      // da Sibling-Farben immer alle sichtbar bleiben sollen.
    }
  }
  customElements.define('references-picker', ReferencesPicker);
}